import { useId } from 'react';

import { IFCWithChildren } from '~/common/interfaces/IFCWithChildren';
import { IAboveComponentDefaultProps } from '~/common/interfaces/IAboveComponentDefaultProps';
import { useClickOutside } from '~/common/hooks/use-click-outisde';
import { useAboveElementPossiblePosition } from '~/common/hooks/use-above-element-possible-position';

import { AboveContainer } from '../Tooltip/styles';
import { AboveBox } from '../Box';

export type TPositioningProperties = {
  top?: number | string;
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
};

interface IPopoverProps extends IAboveComponentDefaultProps {
  open: boolean;
  close: () => void;
  positioning?: TPositioningProperties;
  withoutPadding?: boolean;
}
export const Popover: IFCWithChildren<IPopoverProps> = ({
  arrowPosition = 'center',
  background = 'neutral.50',
  orientation = 'vertical',
  positioning = {},
  withoutPadding = false,
  open = false,
  close,
  children,
}) => {
  const popoverId = useId();
  const containerRef = useClickOutside<HTMLDivElement>(close);

  const position = useAboveElementPossiblePosition({
    orientation,
    visible: open,
    containerRef,
    boxId: popoverId,
  });

  return (
    <AboveContainer
      popover
      ref={containerRef}
      style={{
        position: 'absolute',
        ...positioning,
      }}
    >
      <AboveBox
        popover
        id={popoverId}
        visible={open}
        position={position}
        arrowPosition={arrowPosition}
        background={background}
        withoutPadding={withoutPadding}
      >
        {children}
      </AboveBox>
    </AboveContainer>
  );
};
